var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-barcode-bind" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-info" }, [
        _c("div", { staticClass: "header-title" }, [_vm._v("设备列表")]),
        _c("div", { staticClass: "header-count" }, [
          _vm._v("当前已录入" + _vm._s(_vm.list.length) + "台设备")
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "header-record-btn",
          on: { click: _vm.onclickRecordBtn }
        },
        [_vm._v("记 录")]
      )
    ]),
    _vm.list.length
      ? _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.list, function(item, index) {
            return _c("div", { key: index, staticClass: "item" }, [
              _c("div", { staticClass: "item-left" }, [
                _c("img", {
                  staticClass: "icon-feeder",
                  attrs: { src: _vm.ossPondHost + "img/xiazeng_icon.png" }
                }),
                _c("div", { staticClass: "item-info" }, [
                  _c("div", { staticClass: "item-unique-id" }, [
                    _vm._v(_vm._s(item.uniqueId))
                  ]),
                  _c("div", { staticClass: "item-barcode" }, [
                    _vm._v(_vm._s(item.barcode))
                  ])
                ])
              ]),
              _c(
                "div",
                {
                  staticClass: "item-remove-btn",
                  on: {
                    click: function($event) {
                      return _vm.onclickRemoveBtn(index)
                    }
                  }
                },
                [_vm._v("移除")]
              )
            ])
          }),
          0
        )
      : _vm._e(),
    !_vm.list.length
      ? _c("div", { staticClass: "empty-box" }, [
          _c("img", {
            attrs: { src: _vm.ossPondHost + "img/empty_controller.png" }
          }),
          _c("div", { staticClass: "empty-tip" }, [
            _vm._v("暂未录入设备,请点击+号录入")
          ])
        ])
      : _vm._e(),
    _c("div", { staticClass: "footer" }, [
      _c(
        "div",
        {
          class: [
            "btn-submit",
            { disabled: !_vm.list.length || _vm.submitting }
          ],
          on: { click: _vm.onclickSubmitBtn }
        },
        [_vm._v("确认提交")]
      )
    ]),
    _c(
      "div",
      {
        staticClass: "fab-add",
        on: {
          click: function($event) {
            _vm.showAddDialog = true
          }
        }
      },
      [_c("span", { staticClass: "fab-icon" }, [_vm._v("+")])]
    ),
    _vm.showAddDialog
      ? _c(
          "div",
          {
            staticClass: "dialog-mask",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeDialog($event)
              }
            }
          },
          [
            _c("div", { staticClass: "dialog-content" }, [
              _c("div", { staticClass: "dialog-scan-icon" }, [
                _c("img", {
                  attrs: { src: _vm.ossPondHost + "img/xiazeng_icon.png" }
                })
              ]),
              _c("div", { staticClass: "dialog-field" }, [
                _c("span", { staticClass: "field-label" }, [_vm._v("设备号")]),
                !_vm.addForm.uniqueId
                  ? _c(
                      "div",
                      {
                        staticClass: "field-right",
                        on: { click: _vm.onclickScanDevice }
                      },
                      [
                        _c("span", { staticClass: "field-scan-text" }, [
                          _vm._v("扫码录入")
                        ])
                      ]
                    )
                  : _c("div", { staticClass: "field-right" }, [
                      _c("span", { staticClass: "field-value" }, [
                        _vm._v(_vm._s(_vm.addForm.uniqueId))
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "field-rescan",
                          on: { click: _vm.onclickScanDevice }
                        },
                        [_vm._v("重扫")]
                      )
                    ])
              ]),
              _c("div", { staticClass: "dialog-field" }, [
                _c("span", { staticClass: "field-label" }, [_vm._v("条形码")]),
                !_vm.addForm.barcode
                  ? _c(
                      "div",
                      {
                        staticClass: "field-right",
                        on: { click: _vm.onclickScanBarcode }
                      },
                      [
                        _c("span", { staticClass: "field-scan-text" }, [
                          _vm._v("扫码录入")
                        ])
                      ]
                    )
                  : _c("div", { staticClass: "field-right" }, [
                      _c("span", { staticClass: "field-value" }, [
                        _vm._v(_vm._s(_vm.addForm.barcode))
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "field-rescan",
                          on: { click: _vm.onclickScanBarcode }
                        },
                        [_vm._v("重扫")]
                      )
                    ])
              ]),
              _c("div", { staticClass: "dialog-field" }, [
                _c("span", { staticClass: "field-label" }, [_vm._v("批次号")]),
                _c(
                  "div",
                  {
                    staticClass: "field-right field-right-batch",
                    class: { disabled: !_vm.batchList.length },
                    on: { click: _vm.onclickBatchField }
                  },
                  [
                    _c(
                      "span",
                      {
                        class: [
                          "field-batch-text",
                          {
                            placeholder:
                              !_vm.addForm.batchName && _vm.batchList.length
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.addForm.batchName ||
                                (_vm.batchList.length
                                  ? "请选择"
                                  : "未获取到批次号")
                            ) +
                            " "
                        )
                      ]
                    ),
                    _c("Icon", {
                      staticClass: "field-arrow",
                      attrs: { name: "arrow-down" }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "dialog-buttons" }, [
                _c(
                  "div",
                  {
                    staticClass: "dialog-btn dialog-btn-cancel",
                    on: { click: _vm.closeDialog }
                  },
                  [_vm._v(_vm._s(_vm.list.length > 0 ? "结束录入" : "取 消"))]
                ),
                _c(
                  "div",
                  {
                    class: [
                      "dialog-btn",
                      "dialog-btn-confirm",
                      { disabled: !_vm.batchList.length }
                    ],
                    on: { click: _vm.onclickConfirmAdd }
                  },
                  [_vm._v("确 定")]
                )
              ])
            ])
          ]
        )
      : _vm._e(),
    _vm.showBatchPicker
      ? _c(
          "div",
          {
            staticClass: "picker-mask",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                _vm.showBatchPicker = false
              }
            }
          },
          [
            _c("div", { staticClass: "picker-content" }, [
              _c("div", { staticClass: "picker-header" }, [
                _c(
                  "span",
                  {
                    staticClass: "picker-cancel",
                    on: {
                      click: function($event) {
                        _vm.showBatchPicker = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _c("span", { staticClass: "picker-title" }, [
                  _vm._v("选择批次号")
                ]),
                _c(
                  "span",
                  {
                    staticClass: "picker-confirm",
                    on: {
                      click: function($event) {
                        _vm.showBatchPicker = false
                      }
                    }
                  },
                  [_vm._v("确定")]
                )
              ]),
              _c(
                "div",
                { staticClass: "picker-list" },
                [
                  _vm._l(_vm.batchList, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "picker-item",
                        class: {
                          active: _vm.addForm.batchName === item.batchName
                        },
                        on: {
                          click: function($event) {
                            return _vm.onSelectBatch(item)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(item.batchName) + " ")]
                    )
                  }),
                  !_vm.batchList.length
                    ? _c("div", { staticClass: "picker-empty" }, [
                        _vm._v("未获取到批次号")
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }